module.exports = __webpack_public_path__ + "static/media/yamato.2abbaa2e.svg";